import { render } from "./Profil.vue?vue&type=template&id=90ce7810"
import script from "./Profil.vue?vue&type=script&lang=ts"
export * from "./Profil.vue?vue&type=script&lang=ts"
script.render = render

export default script